import LevelZeroIcon from "@assets/icons/sourcing-theme-level-zero.svg";
import LevelOneIcon from "@assets/icons/sourcing-theme-level-one.svg";
import LevelThreeIcon from "@assets/icons/sourcing-theme-level-three.svg";
import LevelTwoIcon from "@assets/icons/sourcing-theme-level-two.svg";

import { openThemePage } from "@utils/navigation.util";
import { IThemeTagResponse } from "@interfaces/responses.interface";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IThemeTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IThemeTagResponse) => void;
  onRemove?: (tag: IThemeTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
  isLevelOneBased?: boolean;
}

export function ThemeTag({
  data,
  isDisabled,
  onAdd,
  onRemove,
  withPlusIcon,
  iconOnly,
  isLevelOneBased,
}: Props) {
  const themeLevel = isLevelOneBased ? data.object.level - 1 : data.object.level;

  let Icon;
  switch (themeLevel) {
    case 0:
      Icon = LevelZeroIcon;
      break;
    case 1:
      Icon = LevelOneIcon;
      break;
    case 2:
      Icon = LevelTwoIcon;
      break;
    case 3:
      Icon = LevelThreeIcon;
      break;
    default:
      Icon = LevelThreeIcon;
      break;
  }

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      onRedirect={() => openThemePage(data.object.id)}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
    >
      <Icon width={20} height={20} className="flex-shrink-0" />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{data.object.title}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
